import { render, staticRenderFns } from "./InvAgingForwardView.vue?vue&type=template&id=7000dcc8&scoped=true&"
import script from "./InvAgingForwardView.vue?vue&type=script&lang=js&"
export * from "./InvAgingForwardView.vue?vue&type=script&lang=js&"
import style0 from "./InvAgingForwardView.vue?vue&type=style&index=0&id=7000dcc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000dcc8",
  null
  
)

export default component.exports